import { render } from "./DeliveryClientOrdersList.vue?vue&type=template&id=5978a74a&scoped=true"
import script from "./DeliveryClientOrdersList.vue?vue&type=script&lang=js"
export * from "./DeliveryClientOrdersList.vue?vue&type=script&lang=js"

import "./DeliveryClientOrdersList.vue?vue&type=style&index=0&id=5978a74a&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5978a74a"]])

export default __exports__